import "./global/global";
import { initExampleSections } from "./parts/sections/example-section";
import { initTrustedBy1Sections } from "./parts/sections/trusted-by-section";
import { initMissionStatementSections } from "./parts/sections/mission-statement-section";
import { initOurTeamLeadershipSections } from "./parts/sections/our-team-leadership-section";
import { initSustainabilitySections } from "./parts/sections/sustainability-section";
import { initReviewSliderSections } from "./parts/sections/review-slider-section";
import { initNewsFullSections } from "./parts/sections/news-full-section.js";
import { initMarketsWeServiceSections } from "./parts/sections/markets-we-service-section.js";
import { initProductOrServiceSections } from "./parts/sections/product-or-service-section";
import { initDateSliderSections } from "./parts/sections/date-slider-section";
import { initJobOpeningsSections } from "./parts/sections/job-openings-section";

document.addEventListener('DOMContentLoaded', () => {
    initExampleSections();
    initTrustedBy1Sections();
    initMissionStatementSections();
    initOurTeamLeadershipSections();
    initSustainabilitySections();
    initReviewSliderSections();
    initNewsFullSections();
    initMarketsWeServiceSections();
    initProductOrServiceSections();
    initDateSliderSections();
    initJobOpeningsSections();
    menuMobile();
    circleToogle();
});
function menuMobile(){
    const items = document.querySelectorAll(".menu-item");
    items.forEach(item => {
        item.addEventListener("click", function (e) {
            const submenu = this.querySelector(":scope > .sub-menu");
            if (submenu) {
                e.stopPropagation();
                document.querySelectorAll(".menu-item.submenu-open").forEach(openItem => {
                    if (openItem !== this) {
                        openItem.classList.remove("submenu-open");
                    }
                });
                this.classList.toggle("submenu-open");
            }
        });
    });
    const mobileMenu = document.querySelector('.mobile-menu');
    const menuToggle = document.querySelector('.menu-toogle');
    const closeMenu = document.querySelector('.close-menu');

    menuToggle.addEventListener('click', () => {
        mobileMenu.classList.add('active');
    });

    closeMenu.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
    });
}
function circleToogle(){
    const items = document.querySelectorAll('.mobile-chart .item-chart');
    if (items.length > 0) {
        items[0].classList.add('active');
    }
    items.forEach(item => {
        const title = item.querySelector('.blue-title');

        title.addEventListener('click', () => {
            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');
        });
    });
}